<div class="contact-info">
  <div class="contact-info--left">
    <img
      [src]="
        jobseeker?.photo?.filename
          ? jobseeker.photo.filename
          : 'assets/img/no_image_jobseeker.jpg'
      "
      alt=""
      width="187"
      height="239"
    />
    <app-reject-dialog
      *ngIf="
        (isCreate && !isEdited && jobseeker?.photo?.filename) ||
        (!isCreate &&
          isEdited &&
          changes.entityAttributes.includes(jobseekerEnum.Photo))
      "
      [id]="jobseekerEnum.Photo"
      (setDictionary)="reject($event)"
    >
      {{ 'label.Reject' | translate }}
    </app-reject-dialog>
  </div>
  <div class="contact-info--right">
    <div class="name">
      <span
        [ngClass]="{
          'changed-label':
            changes.entityAttributes.includes(jobseekerEnum.Name) && isEdited
        }"
        >{{ jobseeker?.name }}</span
      >
      <app-reject-dialog
        *ngIf="
          isEdited && changes.entityAttributes.includes(jobseekerEnum.Name)
        "
        [id]="jobseekerEnum.Name"
        (setDictionary)="reject($event)"
      >
        {{ 'label.Reject' | translate }}
      </app-reject-dialog>
      <span
        [ngClass]="{
          'changed-label':
            changes.entityAttributes.includes(jobseekerEnum.Surname) && isEdited
        }"
        >{{ jobseeker?.surname }}</span
      >
      <app-reject-dialog
        *ngIf="
          isEdited && changes.entityAttributes.includes(jobseekerEnum.Surname)
        "
        [id]="jobseekerEnum.Surname"
        (setDictionary)="reject($event)"
      >
        {{ 'label.Reject' | translate }}
      </app-reject-dialog>
    </div>
    <div class="mail">
      <span
        class="mail"
        [ngClass]="{
          'changed-label':
            changes.entityAttributes.includes(jobseekerEnum.Email) && isEdited
        }"
        ><svg-icon src="assets/img/mail.svg"></svg-icon
        >{{ jobseeker.email }}</span
      >
      <app-reject-dialog
        *ngIf="
          isEdited && changes.entityAttributes.includes(jobseekerEnum.Email)
        "
        [id]="jobseekerEnum.Email"
        (setDictionary)="reject($event)"
      >
        {{ 'label.Reject' | translate }}
      </app-reject-dialog>
    </div>
    <div class="phone">
      <span
        class="phone"
        *ngIf="jobseeker.phoneNumber"
        [ngClass]="{
          'changed-label':
            changes.entityAttributes.includes(jobseekerEnum.PhoneNumber) &&
            isEdited
        }"
        ><svg-icon src="assets/img/mobile_jobseeker.svg"></svg-icon
        >{{ jobseeker.phoneNumber }}</span
      >
      <app-reject-dialog
        *ngIf="
          isEdited &&
          changes.entityAttributes.includes(jobseekerEnum.PhoneNumber)
        "
        [id]="jobseekerEnum.PhoneNumber"
        (setDictionary)="reject($event)"
      >
        {{ 'label.Reject' | translate }}
      </app-reject-dialog>
      <span
        *ngIf="jobseeker.phoneNumber2"
        [ngClass]="{
          'changed-label':
            changes.entityAttributes.includes(jobseekerEnum.PhoneNumber2) &&
            isEdited
        }"
        >{{ jobseeker.phoneNumber2 }}</span
      >
      <app-reject-dialog
        *ngIf="
          isEdited &&
          changes.entityAttributes.includes(jobseekerEnum.PhoneNumber2)
        "
        [id]="jobseekerEnum.PhoneNumber2"
        (setDictionary)="reject($event)"
      >
        {{ 'label.Reject' | translate }}
      </app-reject-dialog>
    </div>
    <span
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.Gender) && isEdited
      }"
      >{{ 'label.Gender' | translate }}:
      <span>{{ jobseeker.genderName }}</span>
    </span>
    <span
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.DateOfBirth) &&
          isEdited
      }"
      >{{ 'label.DateOfBirth' | translate }}:
      <span *ngIf="jobseeker.dateOfBirth">{{
        jobseeker.dateOfBirth | date : 'dd/MM/yyyy'
      }}</span></span
    >
    <span
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.ExtendedLocationId) &&
          isEdited
      }"
      >{{ 'label.CurrentLocation' | translate }}:
      <span
        *ngFor="let location of jobseeker.extendedLocations; let last = last"
        >{{ last ? location + '.' : location + ', ' }}</span
      ></span
    >
    <span
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.Address) && isEdited
      }"
      >{{ 'label.ExactAddress' | translate }}:
      <span>{{ jobseeker.address }}</span></span
    >
    <span
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.LegalAddress) &&
          isEdited
      }"
      >{{ 'label.LegalAddress' | translate }}:
      <span>{{ jobseeker.legalAddress }}</span></span
    >

    <span
      *ngIf="jobseeker?.drivingLicenses as licence"
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.DrivingLicense) &&
          isEdited
      }"
      >{{ 'label.DrivingLicence' | translate }}:
      <span *ngIf="licence.length && licence.length > 0">
        <span *ngFor="let drivingLicence of licence; let last = last">{{
          '(' + (last ? drivingLicence : drivingLicence + ', ') + ')'
        }}</span>
      </span>
      <span *ngIf="licence.length === 0">
        {{ 'label.No' | translate }}
      </span>
    </span>
    <span
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.IsVehicleOwner) &&
          isEdited
      }"
      >{{ 'label.OwnVehicle' | translate }}:
      <span>{{
        jobseeker?.isVehicleOwner
          ? ('label.Yes' | translate)
          : ('label.No' | translate)
      }}</span></span
    >
    <span
      [ngClass]="{
        'changed-label':
          changes.entityAttributes.includes(jobseekerEnum.VehicleType) &&
          isEdited
      }"
      >{{ 'label.TransportType' | translate }}:
      <span *ngFor="let vehicle of jobseeker?.vehicleTypes; let last = last">{{
        last ? vehicle + '.' : vehicle + ', '
      }}</span></span
    >
  </div>
</div>
